import { instance } from "@/services/API";

// Caller's account and company from backoffice. Returns null on 404 (backoffice has no
// record of the user) so the profile page can fall back to the Firebase email.
export const fetchUserAccount = async () => {
  try {
    const response = await instance.get("/user/account");
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
};
